module.exports = __webpack_public_path__ + "static/user-research-number-3-c20b697c3b7427064b60ecf95a7dde3a.png";